var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5283_13596)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2041 13.2054C20.3668 13.0426 20.6306 13.0426 20.7933 13.2054L22.9987 15.4107L25.2041 13.2054C25.3668 13.0426 25.6306 13.0426 25.7933 13.2054C25.956 13.3681 25.956 13.6319 25.7933 13.7946L23.588 16L25.7933 18.2054C25.956 18.3681 25.956 18.6319 25.7933 18.7946C25.6306 18.9573 25.3668 18.9573 25.2041 18.7946L22.9987 16.5892L20.7933 18.7946C20.6306 18.9573 20.3668 18.9573 20.2041 18.7946C20.0414 18.6319 20.0414 18.3681 20.2041 18.2054L22.4094 16L20.2041 13.7946C20.0414 13.6319 20.0414 13.3681 20.2041 13.2054Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5283_13596",
    x: 0,
    y: -2,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.121569 0 0 0 0 0.988235 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5283_13596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5283_13596",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.48e2d3a65d8eb37469c36fb2d1e51ee2.svg";
export { ForwardRef as ReactComponent };